import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { SendCMD } from "@/utils/HTTPRequest";
import React, { useContext, useState, useEffect } from "react";
import style from "./style.less";
import { FunctionalConfig } from "@/config";

const HomeTabNav2 = ({ activeIndex, onTabChange }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(activeIndex ? activeIndex : 0);
  const { getPersist, setPersist } = React.useContext(PersistContext);
  const { getLanguage, langText } = useContext(LanguageContext);
  const [reward, setReward] = useState(0);
  const [luckyRed, setLuckyRed] = useState(false)
  //为true时表示收入，为false时表示伸出
  const [shouNa, setShouNa] = useState(true)
  const history = useEnhancedHistory();

  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const handleTouchStart = (e) => {
    setStartPos({
      x: e.touches[0].clientX,
      y: e.touches[0].clientY
    });
  };

  useEffect(() => {
    if (shouNa) return;
    const handleGlobalClick = () => setShouNa(true);
    const handleTouchMove = (e) => {
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const deltaX = Math.abs(currentX - startPos.x);
      const deltaY = Math.abs(currentY - startPos.y);
      if (deltaX + deltaY > 15) {
        setShouNa(true);
        e.preventDefault();
      }
    };
    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener("click", handleGlobalClick);
    return () => {
      document.removeEventListener("click", handleGlobalClick);
      document.removeEventListener('touchmove', handleTouchMove);
    }
  }, [!shouNa]);

  useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      return;
    }
    if (FunctionalConfig.newPromotion) {
      SendCMD("piggyBankGetInfo", { token: getPersist("user_info").token }).then((res) => {
        if (!res.status) {
          console.log(res.errdesc);
        } else {
          console.log(res.info)
          setReward(res.info.reward)
        }
      });
    }
  }, [getPersist("user_info")]);

  useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      return;
    }
    // lucky的红点每天弹一次，满足旋转条件的时候显示
    if (getPersist("luckyDrawRedDay") != new Date().getDay()) {
      setLuckyRed(true);
      return
    }
    setLuckyRed(getPersist("user_info")["money"]["silver_coin"] >= 2000)
  }, [(getPersist("user_info") && getPersist("user_info")["money"]["silver_coin"]), getPersist("luckyDrawRedDay")])

  const onTabClick = (index) => {
    setSelectedIndex(index);
    if (typeof onTabChange == "function") {
      onTabChange(index);
    }
  };

  const gotoDeposit = () => {
    history.push(ChannelRemind("/home"));
  };

  return (
    <ul class={style.tab_container} style={getLanguage() == "bem" && { marginTop: "-0.2rem" }}>
      <li onClick={() => history.push(ChannelRemind("/FreeCash"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img class={!getPersist("makeMoneyReaded") && style.btn_anim} src={require("@/assets/images/home/class_icon/icon_MakeMoney.png").default} />
          <span style={{ width: "110%", marginRight: "0.4rem", marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("freecash_title_1")}</span>
        </div>
      </li>
      <li
        onClick={() => {
          if (FunctionalConfig.newPromotion) {
            onTabClick(2);
          } else {
            onTabClick(1);
          }
        }}
      >
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_TaskCenter.png").default} />
          <span style={{ marginTop: "-0.9rem", lineHeight: "0.98", textWrap: "nowrap" }}>{langText("home_btn_getCoins")}</span>
        </div>
      </li>

      {FunctionalConfig.newPromotion ? (
        <li onClick={() => history.push(ChannelRemind("/PiggyBank"))}>
          <div class={style.tab_normal} style={{ height: "1rem" }}>
            <img src={require("@/assets/images/home/class_icon/icon_FortuneCow.png").default} />
            <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("home_btn_piggyBank")}</span>
            {reward > 0 ? (
              <img class={style.hongdian} src={require("@/assets/images/home/class_icon/hongdian.png").default} />
            ) : (
              <></>
            )}
          </div>
        </li>
      ) : (
        <li onClick={() => history.push(ChannelRemind("/Deposit"))}>
          <div class={style.tab_normal} style={{ height: "1rem" }}>
            <img src={require("@/assets/images/home/class_icon/icon_Deposil.png").default} />
            <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("home_btn_deposit")}</span>
          </div>
        </li>
      )}

      <li onClick={() => history.push(ChannelRemind("/Leaderboard"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_Leaderboard.png").default} />
          <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("Rankings")}</span>
        </div>
      </li>

      <li onClick={() => history.push(ChannelRemind("/invite"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_Promotion.png").default} />
          <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{FunctionalConfig.indiaLeader || FunctionalConfig.pakistanLeader ? langText("home_btn_brokerage") : langText("home_btn_promotion")}</span>
        </div>
      </li>

      {/* <li onClick={() => history.push(ChannelRemind("/taskCenter"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_GetCoins.png").default} />
          <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("home_btn_taskCenter")}</span>
        </div>
      </li> */}
      {/* <li onClick={() => history.push(ChannelRemind("/taskCenter"))}>
        <div class={style.tab_normal} style={{ height: "1rem" }}>
          <img src={require("@/assets/images/home/class_icon/icon_shouna.png").default} />
          <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("home_btn_taskCenter")}</span>
        </div>
      </li> */}
      {shouNa ? (
        <li onClick={() => {setShouNa(false)}}>
          <div class={style.tab_normal} style={{ height: "1rem", marginTop: "0.7rem" }}>
            <img src={require("@/assets/images/home/class_icon/icon_shouna.png").default} />
            <span style={{ marginTop: "-0.9rem", lineHeight: "0.98" }}>{langText("")}</span>
          </div>
        </li>
      ) : (
        <li class={style.tab_normal}>
          <div >
            <img style={{ width: "3.5rem", marginTop:"-0.1rem" }} src={require("@/assets/images/home/class_icon/shouna_bg.png").default} />
            <ul class={style.tab_container_right}>
              <li class={style.tab_container_right_icon} onClick={(e) => {
                e.stopPropagation();
                setShouNa(true)
              }}>
                <div class={style.tab_normal} style={{ height: "1rem", fontSize: "0.6rem" }}>
                  <img style={{ pointerEvents: "none" }} src={require("@/assets/images/home/class_icon/icon_shouna.png").default} />
                </div>
              </li>

              <li class={style.tab_container_right_li} onClick={() => history.push(ChannelRemind("/taskCenter"))}>
                <div class={style.tab_normal} style={{ height: "1rem", fontSize: "0.6rem" }}>
                  <img src={require("@/assets/images/home/class_icon/icon_GetCoins.png").default} />
                  <span style={{ marginTop: "-0.9rem", marginRight:"0.2rem", lineHeight: "0.98" }}>{langText("home_btn_taskCenter")}</span>
                </div>
              </li>

              <li class={style.tab_container_right_li} onClick={() => history.push(ChannelRemind("/luckyDraw"))}>
                <div class={style.tab_normal} style={{ height: "1rem" }}>
                  <img src={require("@/assets/images/home/class_icon/icon_LuckyDraw.png").default} />
                  <span style={{ marginTop: "-0.9rem", marginRight:"0.2rem", lineHeight: "0.98" }}>{langText("home_btn_luckyDraw")}</span>
                  {luckyRed ? (
                    <img class={style.hongdian} src={require("@/assets/images/home/class_icon/hongdian.png").default} />
                  ) : (
                    <></>
                  )}
                </div>
              </li>
            </ul>
          </div>
        </li>
      )}


    </ul>
  );
};

export default HomeTabNav2;
